export default {
    serialize: function (obj) {
        if (!obj || typeof obj !== "object")
            return "";
        var str = [];
        var _loop_1 = function (key) {
            if (!obj.hasOwnProperty(key) || obj[key] === undefined)
                return "continue";
            if (typeof obj[key] == "object" && Array.isArray(obj[key])) {
                obj[key].forEach(function (item) {
                    str.push(encodeURIComponent(key) + "=" + encodeURIComponent(item));
                });
            }
            else {
                str.push(encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]));
            }
        };
        for (var key in obj) {
            _loop_1(key);
        }
        return str.join("&");
    },
    deserialize: function (str) {
        var result = {};
        if (str && typeof str === "string") {
            var parts = str.split(/&|\?/);
            for (var i = 0; i < parts.length; i++) {
                var part = parts[i].split("=");
                if (part.length !== 2)
                    continue;
                var key = decodeURIComponent(part[0]);
                var value = decodeURIComponent(part[1]);
                if (typeof result[key] == "string") {
                    result[key] = [result[key], value];
                }
                else if (typeof result[key] == "object" && Array.isArray(result[key])) {
                    result[key].push(value);
                }
                else {
                    result[key] = value;
                }
            }
        }
        return result;
    }
};
